import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Grid,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  useToast,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Select,
  Textarea,
  useColorModeValue
} from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { decodeToken } from 'react-jwt'

import useParametrizationSupply from '@hook/parametrization/use-supply'
import useFilters from '@hook/shared/use-filters'

import Filter from '@component/Shared/Filter'

const ParametrizationSupplyModalEdit: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()

  const selectBg = 'white'
  const selectBorderColor = useColorModeValue('gray.200', 'gray.600')
  const selectTextColor = 'black'
  const optionBg = 'white'
  const optionColor = 'black'
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  )
  const token = userInfos?.body?.access_token

  const decodedToken: any = decodeToken(token)
  let idsVisible: any[] = []
  if (decodedToken?.parametrosAbastecimento) {
    idsVisible = decodedToken
      ? decodedToken?.parametrosAbastecimento?.split(',')
      : []
  }

  const {
    filterEdit,
    loading,
    paramsEdit,
    handleUpdateEditParams,
    setData,
    selecteds,
    canSaveRecord,
    data,
    comentario,
    setComentario
  } = useParametrizationSupply()

  const { getFilters } = useFilters()
  useEffect(() => {
    getFilters({
      inventoryStatus: true
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleSelectChange = (id: string, value: any) => {
    // Converte para number se for o campo abastercer
    const processedValue = id === 'abastercer' ? value : value
    handleUpdateEditParams({ name: id, value: processedValue })
  }
  // const removedRadioButton = (id: string, value: any) => {
  //   setCounter(counter + 1)
  //   if (counter === 2) {
  //     handleUpdateEditParams({ name: id, value: '' })
  //     setCounter(0)
  //     setChange(false)
  //   } else {
  //     if (change) {
  //       // Converte para number se for o campo abastercer
  //       const processedValue = id === 'abastercer' ? value : value
  //       handleUpdateEditParams({ name: id, value: processedValue })
  //     } else {
  //       setChange(true)
  //     }
  //   }
  // }

  // Validação dos campos obrigatórios quando Abastecer = Sim
  const mustSupply =
    paramsEdit.abastercer === 1 || paramsEdit.abastercer === '1'

  const requiredFieldsValidation = useMemo(() => {
    if (!mustSupply) {
      return { isValid: true, missingFields: [] }
    }

    const missingFields: string[] = []

    // Campos obrigatórios quando Abastecer = Sim
    const requiredChecks = [
      {
        value: paramsEdit.tipoSuprimento,
        name: 'Tipo de Suprimento',
        visible: idsVisible.includes('2')
      },
      {
        value: paramsEdit.maximo,
        name: 'EMax',
        visible: idsVisible.includes('6')
      },
      {
        value: paramsEdit.frequenciaDePedidos,
        name: 'Frequência de Pedidos',
        visible: idsVisible.includes('7')
      },
      {
        value: paramsEdit.leadTime,
        name: 'Lead Time',
        visible: idsVisible.includes('8')
      },
      {
        value: paramsEdit.loteMultiplo,
        name: 'Lote Múltiplo',
        visible: idsVisible.includes('9')
      },
      {
        value: paramsEdit.politicaDeEstoqueArbitraria,
        name: 'Política de Estoque Arbitrária',
        visible: idsVisible.includes('10')
      },
      {
        value: paramsEdit.loteMinimoCD,
        name: 'Lote Mínimo CD',
        visible: idsVisible.includes('11')
      }

      // {
      //   value: paramsEdit.estoqueMinimo,
      //   name: 'Estoque Mínimo',
      //   visible: idsVisible.includes('13')
      // }
    ]

    for (const { value, name, visible } of requiredChecks) {
      if (visible && (value === '' || value === null || value === undefined)) {
        missingFields.push(name)
      }
    }

    // CD Origem é obrigatório para centros diferentes de 1500
    if (idsVisible.includes('14')) {
      // Verifica se algum dos registros selecionados tem centro diferente de 1500
      const selectedRecords = data.filter(record =>
        selecteds.includes(record['id-id'])
      )
      const hasNonMainCenters = selectedRecords.some(record => {
        const centroCode = parseInt(record['centro-codigo'])
        return centroCode !== 1500
      })

      if (
        hasNonMainCenters &&
        (paramsEdit.cdDeOrigem === '' ||
          paramsEdit.cdDeOrigem === null ||
          paramsEdit.cdDeOrigem === undefined)
      ) {
        missingFields.push('CD de Origem (obrigatório para centros ≠ 1500)')
      }
    }

    return {
      isValid: missingFields.length === 0,
      missingFields
    }
  }, [mustSupply, paramsEdit, idsVisible, data, selecteds])

  const validate = () => {
    // Verifica se há alguma alteração nos parâmetros
    const hasChanges = !(
      paramsEdit.abastercer === '' &&
      paramsEdit.tipoSuprimento === '' &&
      paramsEdit.politicaEstoque === '' &&
      paramsEdit.incluirPrevisaoLeadTime === '' &&
      paramsEdit.maximo === '' &&
      paramsEdit.frequenciaDePedidos === '' &&
      paramsEdit.leadTime === '' &&
      paramsEdit.loteMultiplo === '' &&
      paramsEdit.politicaDeEstoqueArbitraria === '' &&
      paramsEdit.loteMinimoCD === '' &&
      paramsEdit.estoqueArbitrado === '' &&
      paramsEdit.cdDeOrigem === '' &&
      paramsEdit.status === '' &&
      paramsEdit.clusterCentro === '' &&
      paramsEdit.utilizarEstoqueMinimo === '' &&
      paramsEdit.estoqueMinimo === '' &&
      paramsEdit.clusterProduto === '' &&
      paramsEdit.utilizarPontoPedido === ''
    )

    if (!hasChanges) {
      toast({
        title: 'Atenção!',
        description: 'É necessário alterar ao menos 1 parâmetro',
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
      return
    }
    setData()
    onClose()
  }
  return (
    <>
      {idsVisible.length > 0 && (
        <>
          <Button
            fontSize={14}
            size="sm"
            color="#4b64c9"
            borderRadius={5}
            border="1px solid #4b64c9"
            cursor="pointer"
            disabled={selecteds.length === 0}
            transition="all ease .2s"
            _hover={{
              background: '#c0d9ff',
              color: '#2d3b72'
            }}
            onClick={onOpen}
          >
            Editar
          </Button>
        </>
      )}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={idsVisible.length > 4 ? '6xl' : 'xl'}
        isCentered
      >
        <ModalOverlay />
        <ModalContent background={'white'} marginX={[4, 8, 16]}>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                Parametros de Abastecimento
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={2} py={4}>
            <Grid
              templateColumns={
                idsVisible.length > 4
                  ? 'repeat(5, 1fr)'
                  : `repeat(${idsVisible.length}, 1fr)`
              }
              gap={6}
            >
              {idsVisible.includes('2') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Tipo de Suprimento</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={paramsEdit.tipoSuprimento}
                      onChange={e =>
                        handleSelectChange('tipoSuprimento', e.target.value)
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="3">Centro Distribuição</option>
                      <option value="1">Fornecedor</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('1') && (
                <>
                  <FormControl>
                    <FormLabel> Abastecer</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={String(paramsEdit.abastercer)}
                      onChange={e =>
                        handleSelectChange('abastercer', e.target.value)
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('6') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Emax</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.maximo}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'maximo',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('8') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Lead Time</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.leadTime}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'leadTime',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('11') && (
                <>
                  <FormControl isRequired>
                    <FormLabel>Lote Mínimo CD</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.loteMinimoCD}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'loteMinimoCD',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('9') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Lote Múltiplo</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.loteMultiplo}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'loteMultiplo',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('13') && (
                <>
                  <FormControl>
                    <FormLabel> Estoque Mínimo</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.estoqueMinimo}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'estoqueMinimo',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('5') && (
                <>
                  <FormControl>
                    <FormLabel> Utilizar o Estoque Mínimo?</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={paramsEdit.utilizarEstoqueMinimo}
                      onChange={e =>
                        handleSelectChange(
                          'utilizarEstoqueMinimo',
                          e.target.value
                        )
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('10') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Política Arbitrada</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.politicaDeEstoqueArbitraria}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'politicaDeEstoqueArbitraria',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('3') && (
                <>
                  <FormControl>
                    <FormLabel> Utilizar Política Otimizada</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={paramsEdit.politicaEstoque}
                      onChange={e =>
                        handleSelectChange('politicaEstoque', e.target.value)
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('4') && (
                <>
                  <FormControl>
                    <FormLabel> Incluir Projeção?</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={paramsEdit.incluirPrevisaoLeadTime}
                      onChange={e =>
                        handleSelectChange(
                          'incluirPrevisaoLeadTime',
                          e.target.value
                        )
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('18') && (
                <>
                  <FormControl>
                    <FormLabel>Utilizar Ponto de Pedido</FormLabel>
                    <Select
                      borderColor={selectBorderColor}
                      bg={selectBg}
                      color={selectTextColor}
                      value={paramsEdit.utilizarPontoPedido}
                      onChange={e =>
                        handleSelectChange(
                          'utilizarPontoPedido',
                          e.target.value
                        )
                      }
                      sx={{
                        option: {
                          bg: optionBg,
                          color: optionColor,
                          _selected: {
                            bg: optionBg,
                            color: optionColor
                          }
                        }
                      }}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Sim</option>
                      <option value="2">Não</option>
                    </Select>
                  </FormControl>
                </>
              )}

              {idsVisible.includes('7') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Frequência de Pedidos </FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.frequenciaDePedidos}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'frequenciaDePedidos',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )}

              {/* {idsVisible.includes('12') && (
                <>
                  <FormControl isRequired>
                    <FormLabel> Estoque Arbitrado</FormLabel>
                    <NumberInput
                      borderBottomColor="black"
                      value={paramsEdit.estoqueArbitrado}
                      onChange={value =>
                        handleUpdateEditParams({
                          name: 'estoqueArbitrado',
                          value: value
                        })
                      }
                    >
                      <NumberInputField />
                    </NumberInput>
                  </FormControl>
                </>
              )} */}

              {idsVisible.includes('14') && (
                <>
                  <Filter
                    label={`CD de Origem${(() => {
                      // Verifica se há centros diferentes de 1500 selecionados
                      const selectedRecords = data.filter(record =>
                        selecteds.includes(record['id-id'])
                      )
                      const hasNonMainCenters = selectedRecords.some(record => {
                        const centroCode = parseInt(record['centro-codigo'])
                        return centroCode !== 1500
                      })
                      return hasNonMainCenters && mustSupply ? ' *' : ''
                    })()}`}
                    options={filterEdit.distributionCenters}
                    value={paramsEdit.cdDeOrigem}
                    onChange={value =>
                      handleUpdateEditParams({ name: 'cdDeOrigem', value })
                    }
                    isLoading={loading}
                  />
                </>
              )}

              {/* {idsVisible.includes('15') && (
                <>
                  {' '}
                  <Filter
                    label="Status"
                    options={inventoryStatus}
                    value={paramsEdit.status}
                    onChange={value =>
                      handleUpdateEditParams({ name: 'status', value })
                    }
                    isLoading={loading}
                  />
                </>
              )} */}
            </Grid>
            <br></br>

            {mustSupply && !requiredFieldsValidation.isValid && (
              <Alert status="info" mt={4}>
                <AlertIcon />
                <Box>
                  <AlertTitle>Dados importantes para configuração</AlertTitle>
                  <AlertDescription>
                    Para uma configuração completa quando &ldquo;Abastecer =
                    SIM&rdquo;, recomendamos preencher os campos indicados.
                    <br />
                    <small>
                      * CD de Origem é necessário quando for tipo de suprimento
                      Centro de Distribuição
                    </small>
                    <br />
                    Campos recomendados:{' '}
                    {requiredFieldsValidation.missingFields.join(', ')}
                  </AlertDescription>
                </Box>
              </Alert>
            )}

            <Grid pt={2} templateColumns="repeat(3, 1fr)" gap={6}></Grid>
            <Grid pt={2} templateColumns="repeat(3, 1fr)" gap={6}></Grid>
            <Grid pt={2} templateColumns="repeat(3, 1fr)" gap={6}></Grid>
            <FormControl mt={4}>
              <FormLabel fontSize="sm">Comentário (opcional)</FormLabel>
              <Textarea
                placeholder="Informe o motivo da alteração..."
                value={comentario}
                onChange={e => setComentario(e.target.value)}
                resize="vertical"
                size="sm"
                maxLength={500}
                rows={3}
                borderColor="black"
                _hover={{ borderColor: 'black' }}
                _focus={{ borderColor: 'black', boxShadow: 'none' }}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter bg="white">
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                validate()
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationSupplyModalEdit
